import * as immutable from 'object-path-immutable';
import * as types from './actionTypes';

const initialState = {
  cash_back: 0,
  composition: [],
  discount_price: 0,
  price: 0,
  isLoading: false,
  isLoaded: false,
  isClearing: false,
  error: '',
  lastAddedItem: null,
  sailplay_discount: 0,
};

export default function cartReducer(state = initialState, action) {
  switch (action.type) {
    case types.ITEMS_UPDATE:
      return {
        ...state,
        ...action.payload,
        isLoaded: true,
        error: '',
      };

    case types.ADD_TO_CART_SUCCESS: {
      return {
        ...state,
        ...action.payload.data,
        lastAddedItem: action.payload.lastAddedItem || state.lastAddedItem,
        isLoaded: true,
        error: '',
      };
    }

    //

    case types.FETCH_ITEMS_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: '',
      };

    case types.FETCH_ITEMS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: '',
        ...action.payload,
      };

    case types.FETCH_ITEMS_FAILURE:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.error,
      };

    case types.ADD_SAILPLAY_DISCOUNT_SUCCESS:
      return {
        ...state,
        error: '',
        ...action.payload,
      };

    case types.ADD_SAILPLAY_DISCOUNT_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    case types.CLEAR_REQUEST:
      return {
        ...state,
        isClearing: true,
      };

    case types.CLEAR_SUCCESS:
      return {
        ...initialState,
        isLoaded: true,
      };

    case types.CLEAR_FAILURE:
      return {
        ...state,
        isClearing: false,
        error: action.error,
      };

    case types.UPDATE_ITEM_REQUEST: {
      const indexOfGoodToUpdate = state.composition.findIndex(good => good.hash === action.payload);

      return immutable.assign(state, ['composition', indexOfGoodToUpdate], {
        updating: true,
        error: '',
      });
    }

    case types.UPDATE_ITEM_SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case types.UPDATE_ITEM_FAILURE: {
      const indexOfGoodToUpdate = state.composition.findIndex(
        good => good.hash === action.payload.hash,
      );

      return immutable.assign(state, ['composition', indexOfGoodToUpdate], {
        updating: false,
        error: action.payload.error,
      });
    }

    case types.REMOVE_ITEM_REQUEST: {
      const indexOfGoodToUpdate = state.composition.findIndex(good => good.hash === action.payload);

      return immutable.assign(state, ['composition', indexOfGoodToUpdate], {
        removing: true,
      });
    }

    case types.REMOVE_ITEM_SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case types.REMOVE_ITEM_FAILURE: {
      const indexOfGoodToUpdate = state.composition.findIndex(
        good => good.hash === action.payload.hash,
      );

      return immutable.assign(state, ['composition', indexOfGoodToUpdate], {
        removing: false,
        error: action.payload.error,
      });
    }
    case types.CHANGE_CART_SAILPLAY_DISCOUNT_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case types.RESET_CART_STATE:
      return {
        ...initialState,
        isLoaded: true,
      };

    default:
      return state;
  }
}
